<template>
    <div id="nav">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              Student Finance Service
            </v-list-item-title>
            <v-list-item-subtitle>
              <br />
                <v-img src="../../../assets/backgrounds/kings_logo.jpg"></v-img>
              <br />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list
          dense
          nav
        >
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link :to="item.path"
            :color="item.color"
          >
            <v-list-item-icon>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </div>
</template>
<script>
import auth from "../../../js/auth.js";

export default {
    name: "navigation",
    data() {
        return {
            items: [
                { 
                  title: "Home", 
                  icon: "mdi-home", 
                  path: "/home",
                  color: "#BDBDBD"
                }
            ],
            right: null
        };
    },
    methods: {
      getConfigResult(){
        const that = this;
        var config = auth.get_user().config;

        if(config.statement.match(/^Yes/i)){
          that.items.push(
            { 
              title: "Fee Statement", 
              icon: "mdi-file-chart", 
              path: "/feestatement",
              color: "#D1C4E9"
            },
          )
        }

        if(config.netbill.match(/^Yes/i)){
          that.items.push(
            { 
              title: "Net Bill", 
              icon: "mdi-file-table", 
              path: "/netbill",
              color: "#80DEEA"
            },
          )
        }

        if(config.t4a.match(/^Yes/i)){
          that.items.push(
            { 
              title: "T4A", 
              icon: "mdi-file-export", 
              path: "/t4a",
              color: "#A5D6A7"
            }
          )
        }

        if(config.t2202a.match(/^Yes/i)){
          that.items.push(
            { 
              title: "T2202A", 
              icon: "mdi-file-star", 
              path: "/t2202a",
              color: "#FFCC80"
            }
          )
        }
      }
    },
    created(){
      const that = this;
      that.getConfigResult();
    }
}
</script>